import {
  IQuotePaymentTermCodeActions,
  QuotePaymentTermCodeContext
} from './actions.types';
import { IQuotePaymentTermCodeData } from '@/models';

export const actions: IQuotePaymentTermCodeActions = {
  fetchQuotePaymentTermCodes(
    context: QuotePaymentTermCodeContext
  ): Promise<void> {
    return this.$services.quotePaymentTermCode
      .fetchQuotePaymentTermCodes()
      .then((codes: IQuotePaymentTermCodeData[]) => {
        context.commit('SET_QUOTE_PAYMENT_TERM_CODES', codes);
      });
  },

  fetchQuotePaymentTermCode(
    context: QuotePaymentTermCodeContext,
    payload: number
  ): Promise<void> {
    return this.$services.quotePaymentTermCode
      .fetchQuotePaymentTermCode(payload)
      .then((code: IQuotePaymentTermCodeData) => {
        const index = context.state.quotePaymentTermCodes.findIndex(
          (v: IQuotePaymentTermCodeData) => v.id === code.id
        );
        if (index === -1) {
          context.commit('ADD_QUOTE_PAYMENT_TERM_CODE', code);
        } else {
          context.commit('UPDATE_QUOTE_PAYMENT_TERM_CODE', code);
        }
      });
  }
};
